module.exports = __webpack_public_path__ + "63e229617d72e04429ec114c2ef1187e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_9.jpg
 ** module id = 614
 ** module chunks = 0
 **/